import { User, Token } from '@insync-students-lib/models';
import { UserAction } from '@insync-students-constants/userActions';
import { SchoolClass } from '@insync-students-lib/models/schoolClass/schoolClass.model';
import { IUserState } from './userContext.provider';
export type ReducerAction = {
  type: UserAction;
  user?: User;
  token?: Token;
  products?: string[];
  classes?: SchoolClass[];
  curricula?: string[];
  schoolYear?: string;
} | {
  type: '';
  payload: {};
};

/**
 * userReducer
 * @param {IUserState}   state      - Current User Context state
 * @param {Action}       action     - Object with action to do and data to update
 */
export const userReducer = (state: IUserState, action: ReducerAction) => {
  switch (action.type) {
    case UserAction.UPDATE_USER:
      {
        return {
          ...state,
          user: new User({
            ...action.user
          })
        };
      }
    case UserAction.UPDATE_TOKEN:
      {
        return {
          ...state,
          token: new Token({
            ...action.token
          })
        };
      }
    case UserAction.UPDATE_PRODUCTS:
      {
        return {
          ...state,
          products: [...action.products]
        };
      }
    case UserAction.UPDATE_CLASSES:
      {
        return {
          ...state,
          classes: [...action.classes]
        };
      }
    case UserAction.UPDATE_CURRICULA:
      {
        return {
          ...state,
          curricula: [...action.curricula]
        };
      }
    default:
      {
        throw new Error(`Unhandled action type: ${action.type}`);
      }
  }
};